import { Component, Input, ViewChild } from '@angular/core';
import { User } from '../../../models/identity/user.model';
import { UserSkillsFormComponent } from '../../../shared/components/user/user-skills-form/user-skills-form.component';
import { AccountsService } from '../../../services/identity/accounts.service';

@Component({
    selector: 'app-onboarding-user-skills',
    templateUrl: './onboarding-user-skills.component.html',
    styleUrls: ['./onboarding-user-skills.component.scss'],
})
export class OnboardingUserSkillsComponent {
    public currentUser: User;
    @ViewChild(UserSkillsFormComponent) public userSkillsComponent: UserSkillsFormComponent;

    constructor(private readonly accountService: AccountsService) {
        this.currentUser = accountService.currentUser;
    }

    public save(): Promise<boolean> {
        return this.userSkillsComponent.save();
    }
}
